import { createHttpLink } from "apollo-link-http";

const uri = process.env.VUE_APP_APPSYNC_URL || "http://localhost:4000/graphql";

const fetcher = (...args) => {
  return window.fetch(...args);
};

export default createHttpLink({
  uri,
  fetch: fetcher,
});
